<template>
    <transition name="slide-fade">
        <div :class="$style.calendar" class="order-calendar" v-show="is_display">
            <div class="header">
                <div class="calendar_label">
                    第{{ calendar_label }}希望
                </div>
                <div class="year-month">
                    {{ year }} 年 {{ month }} 月
                </div>
                <div class="controller">
                    <button type="button" @click="move_to_previous_month();">‹</button>
                    <button type="button" @click="move_to_next_month();">›</button>
                </div>
            </div>
            <table ref="monthly_table">
                <tr>
                    <th>日</th>
                    <th>月</th>
                    <th>火</th>
                    <th>水</th>
                    <th>木</th>
                    <th>金</th>
                    <th>土</th>
                </tr>
                <tr v-for="row in monthly_calendar" :key="row.id">
                    <td v-for="col in row" :key="col.id" @click="setActive($event, year, month, col)">
                        {{ col }}
                    </td>
                </tr>
            </table>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'OrderCalendar',

    props: [ 'bind_id', 'bind_class', 'calendar_label', 'hidden_calendar_event' ],

    data () {
        return {
            year: 2000,
            month: 1,
            monthly_calendar: [],
            is_display: false
        };
    },

    created: function() {
        var today = new Date();
        this.year = today.getFullYear();
        this.month = today.getMonth() + 1;
        this.monthly_calendar = this.get_monthly_calendar(this.year, this.month);
    },

    mounted: function() {
        this.is_display = (this.calendar_label == 1);   //何とかする

        var bind_elem = document.querySelector('#' + this.bind_id);

        var _this = this;
        bind_elem.addEventListener('focus', function () {
            var bind_class_elems = document.querySelectorAll('.' + _this.bind_class).forEach(function (_e) {
                _e.dispatchEvent(_this.hidden_calendar_event);
            });
            _this.is_display = true;
        });
        bind_elem.addEventListener('hidden-calendar', function () {
            _this.is_display = false;
        });
    },

    methods: {
        get_monthly_calendar: function (year, month) {
            var table = [];
            var day = 1;
            var first_day = (new Date(year, month - 1)).getDay();
            var max_day = 32 - new Date(year, month - 1, 32).getDate();
            for (var r = 0; r < 6; r++) {
                if (day > max_day) {
                    break;
                }

                var row = [];
                for (var c = 0; c < 7; c++) {
                    if (day == 1 && c < first_day) {
                        row.push('');
                    } else if (day > max_day) {
                        row.push('');
                    } else {
                        row.push(day.toString());
                        day++;
                    }
                }
                table.push(row);
            }
            return table;
        },

        move_to_previous_month: function() {
            this.month--;
            if (this.month < 1) {
                this.month = 12;
                this.year--;
            }
            this.monthly_calendar = this.get_monthly_calendar(this.year, this.month);
            this.clearActive();
        },

        move_to_next_month: function() {
            this.month++;
            if (this.month > 12) {
                this.month = 1;
                this.year++;
            }
            this.monthly_calendar = this.get_monthly_calendar(this.year, this.month);
            this.clearActive();
        },

        clearActive: function() {
            var td = this.$refs.monthly_table.querySelectorAll(":scope td");
            for (var i = 0; i < td.length; i++) {
                td[i].className = "";
            }
        },

        setActive: function (e, y, m, d) {
            if (d) {    // 空白部分のクリックでは何もしない
                this.clearActive();
                e.currentTarget.className = "active";

                var bind_elem = document.querySelector('#' + this.bind_id);
                console.log('#' + this.bind_id);
                console.log(bind_elem);
                bind_elem.value = y + "/" + m + "/" + d;
            }
        }
    },
};

</script>

<style module>
.calendar {
    .header {
        background-color: red;
        border-top: solid 1px;
        border-bottom: solid 1px;
        border-color: black;
    }
}
</style>